
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import PostLayout from "@src/layouts/PostLayout";
import BorderBox from "@src/components/BorderBox";
import GoogleMap from "@src/components/GoogleMap";
import InstaImage from "@src/components/InstaImage";
import { murakamiMasanori } from "@src/constants/authors";
import { harajukuRizlaboRizlaboTopImage } from "@src/constants/images";
export const meta = {
  path: "/media/harajuku/rizlabo",
  title: "【表参道】テイクアウトもできるグルテンフリーパンケーキ「リズラボキッチン」",
  description: "表参道から少し離れた「裏参道」の古民家の一角にあるふわふわパンケーキの名店「リズラボキッチン」についてご紹介させていただきます。米粉100%グルテンフリーのメニュー、テイクアウトメニュー、オンライン販売など、リズラボキッチンならではの特徴をまとめましたので、パンケーキが大好きな方はぜひ確認してみてください！",
  topImg: harajukuRizlaboRizlaboTopImage,
  author: murakamiMasanori,
  tags: ["駅近", "原宿", "パンケーキ", "人気店", "お店の紹介", "デート", "女子会", "テイクアウト", "グルテンフリー"]
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Text = makeShortcode("Text");
const layoutProps = {
  meta
};
const MDXLayout = ({ children }) => (
  <PostLayout meta={meta}>{children}</PostLayout>
)
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`表参道から少し離れた「裏参道」の古民家の一角にあるふわふわパンケーキの名店「リズラボキッチン」についてご紹介させていただきます。`}</p>
    <p>{`米粉 100%グルテンフリーで作るインスタ映え間違いなしのふわふわパンケーキや、テイクアウトメニュー、オンライン販売など、リズラボキッチンならではの特徴をまとめました！`}</p>
    <p>{`原宿・表参道エリアでパンケーキを食べることを兼用している方は、ぜひリズラボキッチンのパンケーキを確認してみてください！`}</p>
    <h2>{`リズラボキッチンとは？`}</h2>
    <h3>{`裏参道にあるパンケーキ の名店`}</h3>
    <InstaImage postId="B_HBtMFhrJF" mdxType="InstaImage" />
    <p>{`表参道から少し歩くと裏参道と呼ばれるエリアがあります！
そこに裏参道ガーデン という古民家風のお店があり、その中の一つのお店がリズラボキッチンになります！`}</p>
    <InstaImage postId="B8s7__snxLj" mdxType="InstaImage" />
    <h3>{`待ち時間が短い`}</h3>
    <p>{`裏参道エリアは原宿・表参道に比べて少なく、比較的待ち時間も少なくてパンケーキを食べることができます！
`}<strong parentName="p">{`パンケーキは並ばないと入れない`}</strong>{`という状況に陥ることは少ないと思います。`}</p>
    <h3>{`落ち着いた雰囲気`}</h3>
    <p>{`古民家という雰囲気から、落ち着いた雰囲気を感じますが、`}<strong parentName="p">{`店内も照明が暗め`}</strong>{`で大人な雰囲気になっています。
人混みの喧騒から離れた空間でパンケーキを楽しむのは良いですよね。`}</p>
    <h2>{`米粉を使ったグルテンフリーのパンケーキメニュー`}</h2>
    <InstaImage postId="B8kWFL0Ja0Z" mdxType="InstaImage" />
    <p>{`国産の`}<strong parentName="p">{`無農薬の米粉と平飼卵`}</strong>{`を使用して作るパンケーキは、アレルギー体質の方や糖質をなるべく控えたい方にはかなり良いメニューになっています。
また`}<strong parentName="p">{`ふわふわ`}</strong>{`のパンケーキであることも有名で、写真で見てもそのふわふわさが伝わると思うので、そちらも合わせてご紹介させていただきます。`}</p>
    <hr></hr>
    <h2>{`ふわふわのパンケーキ`}</h2>
    <p>{`グルテンフリーで作るパンケーキメニューが４つあり、そのどれもが`}<strong parentName="p">{`ドリンク付きの値段`}</strong>{`設定になっています！
これは非常に嬉しいですね。
他のお店だと別々のことが多いので、パンケーキとドリンクを別々で頼むと 2,000 円を超えてしまうことも多いのですが、そういった心配はありません！`}</p>
    <h3>{`グルテンフリー リズパンケーキ(税込：1,700 円)`}</h3>
    <InstaImage postId="B-_azukhd5A" mdxType="InstaImage" />
    <p>{`写真からもふわふわが伝わる大きなパンケーキが３つ重なったパンケーキ！
北海道産生乳 100%の生クリームに、カナダから届いた有機のアンバータイプのメープルシロップをかけて食べる贅沢な一品！`}</p>
    <h3>{`グルテンフリー 抹茶パンケーキ(税込：1,700 円)`}</h3>
    <InstaImage postId="B9dwcOMnG7r" mdxType="InstaImage" />
    <p>{`裏参道ガーデン内の`}<strong parentName="p">{`宇治園`}</strong>{`というお店から届く`}<strong parentName="p">{`抹茶`}</strong>{`をふんだんに使用しており、北海道産の小豆を焚き上げた`}<strong parentName="p">{`粒あん`}</strong>{`をたっぷり添えた抹茶パンケーキになっています！
プレーンパンケーキと同じくアンバーのメープルシロップ付きなので、いろんな味が楽しめる一品になっています。
これでグルテンフリーなんて信じられないくらいのボリューム感ですよね。`}</p>
    <h3>{`グルテンフリー プレミアムチョコアイス パンケーキ(税込：1,700 円)`}</h3>
    <InstaImage postId="B8m9pMjpGMw" mdxType="InstaImage" />
    <p>{`ふわふわのパンケーキに、たっぷり濃厚なチョコアイスとチョコシロップかかっているパンケーキ！
甘いのが大好きな方にはぜひお勧めしたい一品になっています…！`}</p>
    <h3>{`グルテンフリー 青森産ブラックベリー＆カシスアイス ベリー！ベリー パンケーキ(税込：1,700 円)`}</h3>
    <InstaImage postId="B-3hROcpVsd" mdxType="InstaImage" />
    <p>{`すごく名前が長くて覚えられないパンケーキですよね。笑
有機栽培の青森産ブラックベリーが作るソースをたっぷりかけたパンケーキになっています！フローズンベリーとカシスアイスのひんやりさと温かいパンケーキが心地の良いバランスで合う至極の一品！`}</p>
    <h3>{`【期間限定】北海道ホワイトクリーム＆いちごたっぷりいちごの豆乳ディプロマット＆ルビーチョコいちごのコンフィチュール柔らかアイス (税込：2000 円 )`}</h3>
    <InstaImage postId="B9gdEI1AACY" mdxType="InstaImage" />
    <p>{`2020/2/26 からスタートしているパンケーキになっています！たっぷりとした苺とパンケーキがミックスされていて、これでグルテンフリーなんて信じられないくらいですよね！`}</p>
    <hr></hr>
    <h2>{`テイクアウトができる`}</h2>
    <p>{`コロナの影響もあり、リズラボキッチンではテイクアウトがスタートしました！
人混みを避けて食べたい方や、ご自宅でゆっくり食べたい方は、テイクアウトメニューがおすすめです！`}</p>
    <h3>{`北海道産濃厚生クリームパンケーキサンド(税込 1,760 円)　`}</h3>
    <InstaImage postId="B_4HxGSHNW1" mdxType="InstaImage" />
    <InstaImage postId="B_qlpsYgKQn" mdxType="InstaImage" />
    <p><strong parentName="p">{`テイクアウト・オンライン限定`}</strong>{`のメニューとして、４月からスタートしたこちらのメニュー！
米粉 100%グルテンフリーのパンケーキがサンド型になって、 手で持ってパクッと食べられてしまうサイズ。
ボリュームは満点ですが、ご家族やカップルでカップルで食べると楽しいですよね。`}</p>
    <h3>{`その他限定メニュー`}</h3>
    <InstaImage postId="B_voDNtgi5b" mdxType="InstaImage" />
    <p><strong parentName="p">{`母の日`}</strong>{`はこのようなメニューもテイクアウトで販売していました！`}</p>
    <p>{`予約限定ですが、こういったメニューは中々自宅で作ることができないので、テイクアウトできるのは嬉しいですよね。
こちらもグルテンフリーのパンケーキになっています！`}</p>
    <hr></hr>
    <h2>{`オンライン注文もできる`}</h2>
    <InstaImage postId="B_96viNg0Wl" mdxType="InstaImage" />
    <p>{`オンライン販売が 2020 年 4 月頃からスタートしたそうなので、全国どこでもリズラボキッチンの米粉グルテンフリーパンケーキが食べられるようになりました！
テイクアウトのメニューはもちろんですが、それ以外にもパンケーキの原料の`}{`*`}{`米粉やジャムなども販売しているそうなので、ご自宅で作ってみたい方はそのメニューも購入してみてください！`}</p>
    <p>{`◼︎ 予約・購入ができるサイトはこちら ↓`}</p>
    <p><a parentName="p" {...{
        "href": "https://www.rizlabo.com/web-shop/"
      }}>{`https://www.rizlabo.com/web-shop/`}</a></p>
    <hr></hr>
    <h2>{`支払い方法`}</h2>
    <p>{`電子マネー(Suica 等)とクレジットカードが使えないそうなので、現金を持参していってください…！
導入されると良いのですが、今はまだ現金しか使用できないそうです…！`}</p>
    <BorderBox mdxType="BorderBox">
  <Text as="p" mdxType="Text">
    <Text as="span" fontWeight="bold" mdxType="Text">
      電子マネー：×
    </Text>
    <Text as="span" fontWeight="bold" mdxType="Text">
      クレカ：×
    </Text>
    <Text as="span" fontWeight="bold" mdxType="Text">
      現金：○
    </Text>
  </Text>
    </BorderBox>
    <hr></hr>
    <h2>{`アクセス`}</h2>
    <p>{`表参道から徒歩 5 分の好立地なので、アクセスは抜群になっています！
その他の駅だと、外苑前から徒歩７分、原宿駅から徒歩１０分なので、どちらからもアクセスできる距離になっています！`}</p>
    <GoogleMap lat={35.6695025} lng={139.7215676} mdxType="GoogleMap" />
    <hr></hr>
    <h3>{`おわりに`}</h3>
    <p>{`裏参道ガーデンの`}<strong parentName="p">{`リズラボキッチン`}</strong>{`についてご紹介させていただきましたが、いかがでしたでしょうか？
米粉 100%のグルテンフリーで作るパンケーキや、テイクアウト、オンライン注文などいろんな形でパンケーキを楽しむことができます！
ぜひ、表参道でふわふわのパンケーキを楽しみたい方は、リズラボキッチンへお越しください！`}</p>

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;